<div class="admin-stats">
  <div class="stats-loading" *ngIf="loading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <section class="stats-section">
      <h3 class="stats-heading">{{ 'ADMIN.STATS_OVERVIEW' | translate }}</h3>
      <div class="stats-table-wrap">
        <table class="stats-table">
          <thead>
            <tr>
              <th scope="col" class="row-label-col">&nbsp;</th>
              <th scope="col">{{ 'ADMIN.STATS_TOTAL' | translate }}</th>
              <th scope="col">{{ 'ADMIN.STATS_FREE' | translate }}</th>
              <th scope="col">{{ 'ADMIN.STATS_PREMIUM' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{{ 'ADMIN.STATS_ACCOUNTS' | translate }}</th>
              <td class="empty-cell">&mdash;</td>
              <td class="empty-cell">&mdash;</td>
              <td>{{ accounts.premium | number:'1.0-0' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ 'ADMIN.STATS_USERS' | translate }}</th>
              <td>{{ accounts.totalUsers | number:'1.0-0' }}</td>
              <td>{{ accounts.free | number:'1.0-0' }}</td>
              <td>{{ accounts.premium_users | number:'1.0-0' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ 'ADMIN.STATS_KILNS' | translate }}</th>
              <td>{{ kilns.total | number:'1.0-0' }}</td>
              <td>{{ kilns.free.total | number:'1.0-0' }}</td>
              <td>{{ kilns.premium.total | number:'1.0-0' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ 'ADMIN.STATS_FIRINGS' | translate }}</th>
              <td>{{ kilns.firing | number:'1.0-0' }}</td>
              <td>{{ kilns.free.firing_count | number:'1.0-0' }}</td>
              <td>{{ kilns.premium.firing_count | number:'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="stats-section stats-connectivity">
      <h3 class="stats-heading">{{ 'ADMIN.STATS_CONNECTIVITY' | translate }}</h3>
      <div class="connectivity-grid">
        <div class="stat-card stat-card-online">
          <span class="stat-card-label">{{ 'ADMIN.STATS_ONLINE' | translate }}</span>
          <span class="stat-card-value">{{ kilns.online | number:'1.0-0' }}</span>
        </div>
        <div class="stat-card stat-card-offline">
          <span class="stat-card-label">{{ 'ADMIN.STATS_OFFLINE' | translate }}</span>
          <span class="stat-card-value">{{ kilns.offline | number:'1.0-0' }}</span>
        </div>
        <div class="stat-card stat-card-signins">
          <span class="stat-card-label">{{ 'ADMIN.STATS_SIGN_INS' | translate }}</span>
          <span class="stat-card-value">{{ accounts.loggedInUsers | number:'1.0-0' }}</span>
        </div>
      </div>
    </section>

    <section class="stats-section" *ngIf="kilns.fw_versions?.length">
      <h3 class="stats-heading">{{ 'ADMIN.STATS_FIRMWARE' | translate }}</h3>
      <div class="stats-table-wrap">
        <table class="stats-table stats-table-firmware">
          <thead>
            <tr>
              <th scope="col">{{ 'ADMIN.STATS_FIRMWARE_VERSION' | translate }}</th>
              <th scope="col">{{ 'ADMIN.STATS_FIRMWARE_KILNS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fw of kilns.fw_versions">
              <td>{{ fw.key }}</td>
              <td>{{ fw.value | number:'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>
</div>
